import React, { useEffect } from "react";
import { Navigate, Route, BrowserRouter as Router, Routes, Outlet, useNavigate, useLocation } from "react-router-dom";
import MainLayout from "./layouts/main-layout";
import TournamentTable from "./views/collectives/tournaments/data-grid/tournament";
import TournamentDetail from "./views/collectives/tournaments/detail/tournament-detail";
import Login from "./views/identity/login/login";
import { AuthProvider, useAuth } from "./hooks/AuthContext";
import MatchManagement from "./views/collectives/match-managements/match-management";
import UserManagement from "./views/identity/user-management/data-gird/user-management";
import UserDetailManagement from "./views/identity/user-management/detail/user-detail-management";
import BlogManagement from "./views/collectives/blogs/data-grid/blog";
import ClubManagement from "./views/collectives/clubs/data-grid/club";
import ClubDetailManagement from "./views/collectives/clubs/details/club-detail";
import BlogDetailManagement from "./views/collectives/blogs/detail/blog-detail";
import AuditLogManagement from "./views/audit-log/audit-log-management";
import LeaderBoardManagement from "./views/collectives/leader-board/data-grid/leader-board";
import CoachManagement from "./views/collectives/coaches/data-grid/coach-management";
import CoachDetailManagement from "./views/collectives/coaches/detail/coach-detail-management";

const ProtectedRoute = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (user && location.pathname === "/") {
      navigate('/tournament', { replace: true });
    }
  }, [user, navigate, location.pathname]);

  return !user ? <Login /> : null;
};

const PrivateRoute = () => {
  const { user } = useAuth();
  return user ? <Outlet /> : <Navigate to="/" />;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<ProtectedRoute />} />
          <Route element={<PrivateRoute />}>
            <Route path="/tournament" element={<MainLayout />}>
              <Route index element={<TournamentTable />} />
              <Route path="tournament-detail/new" element={<TournamentDetail />} />
              <Route path="tournament-detail/:tournamentID" element={<TournamentDetail />} />
              <Route path="match-management/:tournamentID" element={<MatchManagement />} />
            </Route>
            <Route path="/user-management" element={<MainLayout />}>
              <Route index element={<UserManagement />} />
              <Route path="user-detail-management/new" element={<UserDetailManagement />} />
              <Route path="user-detail-management/:userId" element={<UserDetailManagement />} />
            </Route>
            <Route path="/blog-management" element={<MainLayout />}>
              <Route index element={<BlogManagement />} />
              <Route path="blog-detail-management/new" element={<BlogDetailManagement />} />
              <Route path="blog-detail-management/:blogID" element={<BlogDetailManagement />} />
            </Route>
            <Route path="/club-management" element={<MainLayout />}>
              <Route index element={<ClubManagement />} />
              <Route path="club-detail-management/new" element={<ClubDetailManagement />} />
              <Route path="club-detail-management/:clubID" element={<ClubDetailManagement />} />
            </Route>
            <Route path="/leader-board-management" element={<MainLayout />}>
              <Route index element={<LeaderBoardManagement />} />
            </Route>
            <Route path="/coach-management" element={<MainLayout />}>
              <Route index element={<CoachManagement />} />
              <Route path="coach-detail-management/:coachID" element={<CoachDetailManagement />} />

            </Route>
            <Route path="/auditlog-management" element={<MainLayout />}>
              <Route index element={<AuditLogManagement />} />
            </Route>
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
